module.exports = __webpack_public_path__ + "static/img/login-bg.4bf92cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-bg.png
// module id = /HQc
// module chunks = 44